import React from 'react';
const BetaFunctionalitySign = () => (
  <span style={{ color: 'green', fontSize: '.5em', position: 'relative', top: '-5px' }}> BETA</span>
);
export default BetaFunctionalitySign;
